import { Field, FieldArray, Form, Formik, ErrorMessage } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";

import nexiLogo from "../.././assets/logo-nexi-group.png";
import styles from "./NewChecklist.module.css";
import { AssessmentSettings } from "./AssessmentSettings/AssessmentSettings";
import { KpiSettings } from "./KpiSettings/KpiSettings";
import { FinalScore } from "./FinalScore/FinalScore";
import * as Yup from "yup";
import DropdownChecklist from "../../components/controls/DropdownChecklist/DropdownChecklist";
import Select from "../../components/controls/Select/Select";
import SubmitButton from "../../components/controls/SubmitButton/SubmitButton";
import { LegalEntityParentCompanyServiceApi } from "../../service/api/LegalEntityParentCompanyServiceApi";
import { ControlFunctionServiceApi } from "../../service/api/ControlFunctionServiceApi";
import { ChecklistServicesApi } from "../../service/api/ChecklistServicesApi";
import { ChecklistPeriodServiceApi, TemplateQuantitativeDriverServiceApi } from "../../service";
import {useHistory} from "react-router-dom";
import {Block} from "../../hoc/Block";
import GenericModal from "../../UI/GenericModal";
import { InputField } from "../../components/controls/InputField/InputField";
import { isSuperuserValue } from "../../access/access";

let urlSearchParams = new URLSearchParams(window.location.search);
let params = Object.fromEntries(urlSearchParams.entries());
let queryStringChecklistId = params["checklistId"];

const initialValues = {
  id: 0,
  legalEntityApiResponse: [],
  controlFunctionsApiResponse: [],
  checklistPeriods: [],
  legalEntityGL: {},
  // selectedGLId: 0,
  legalEntitySubsidiary: {},
  legalEntityCompany: {},
  legalEntityRegion: {name: ""},
  checklistPeriodId: 0,
  controlFunctionId: 0,
  operationalScopeIds: [0],
  checklistTemplateQuantitativeDrivers: [],
  fiscalYear: new Date().getFullYear(),
  supervisedEntity: true,
  operativeCompany: true,
  foreign: true,
  qualitativeOnly: true,
  // qualitativeWeight: 0,
  quantitativeWeight: 1,
  // coverage: 0,
  accuracy: 1,
  'kpiweight-1': 0,
  'kpiweight-2': 0,
  'kpiweight-3': 0,
  'kpiweight-4': 0,
  'kpiweight-5': 0,
  'kpiweight-6': 0
}

// const isEditChecklist = true;

const EditNewChecklist = () => {
  const [error, setError] = useState();
  const [allLegalEntityGL, setAllLegalEntityGL] = useState([])
  const [allLegalEntitySubsidiary, setAllLegalEntitySubsidiary] = useState([])
  const [allLegalEntityCompany, setAllLegalEntityCompany] = useState([])
  const [allChecklistPeriods, setAllChecklistPeriods] = useState([]);

  const [allControlFunctions, setAllControlFunctions] = useState([]);
  const [allOperationalScopes, setAllOperationalScopes] = useState([]);

  const [kpiSettingsHidden, setKpiSettingsHidden] = useState(true);
  const [kpiSettings, setKpiSettings] = useState(false);
  const [isKpiSettingsLoading, setIsKpiSettingsLoading] = useState(false);
  const [operationalScopeIsSelected, setOperationalScopeIsSelected] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [checklistId, setChecklistId] = useState();
  // const [isEditChecklist, setIsEditChecklist] = useState(); 

  const [modalShow, setModalShow] = useState(false);
  const [modalAction, setModalAction] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [modalMessage, setModalMessage] = useState();
  const [modalType, setModalType] = useState();

  const history = useHistory();
  // console.log("InitialValues: ", initialValues);
  useEffect(() => {
    if (!isSuperuserValue()) {
      history.push("/home");
    }
    let mounted = true;
    setIsLoading(true)

    urlSearchParams = new URLSearchParams(window.location.search);
    params = Object.fromEntries(urlSearchParams.entries());
    queryStringChecklistId = params["checklistId"];
    setChecklistId(queryStringChecklistId);
    
    const legalEntityParentCompanyServiceApi = new LegalEntityParentCompanyServiceApi();
        legalEntityParentCompanyServiceApi.getAllLegalEntityParentCompany(true, (compError, parentCompanyData) => {
          if (mounted) {
            if (!compError) {
              console.log("API legal entity: ", parentCompanyData);
              
              // sort api data
              parentCompanyData.sort((a, b) => a.id > b.id ? 1 : -1);
              for (let parentComp of parentCompanyData) {
                parentComp.legalEntitySubsidiaries.sort((a, b) => a.id > b.id ? 1 : -1);
                for (let subsidiary of parentComp.legalEntitySubsidiaries) {
                  if (subsidiary.legalEntityCompanies.length > 0) {
                    subsidiary.legalEntityCompanies.sort((a, b) => a.id > b.id ? 1 : -1);
                  }
                }
              }

              //Store the APi response
              initialValues.legalEntityApiResponse = parentCompanyData;

              const controlFunctionServiceApi = new ControlFunctionServiceApi();
              controlFunctionServiceApi.getAllControlFunctions((cfError, cfData) => {
                if (mounted) {
                  if (!cfError) {
                    console.log("API control functions: ", cfData);
                    // sorting op scopes based on position
                    for (const el of cfData) {
                      el.operationalScopes.sort((a,b) => a.position > b.position ? 1 : -1);
                    }

                    //Store the APi response
                    initialValues.controlFunctionsApiResponse = cfData;
                    
                    setAllControlFunctions(cfData.map((item) => {
                      return {
                        value: item.id,
                        name: item.name
                      }
                    }));
                  } else {
                    setError(() => {
                      throw new Error ("");
                      // throw new Error ("Error " + (cfError.response ? cfError.response.statusCode : "") + " " + cfError.message);
                    })
                  }
                }

                const checklistServicesApi = new ChecklistServicesApi();
                checklistServicesApi.getChecklistById(queryStringChecklistId, (checklistInfoError, checklistData) => {
                  if (mounted) {
                    if (!checklistInfoError) {
                      console.log("checklist information: ", checklistData);
                      if (checklistData.checklistState.name !== "Draft") {
                        setError(() => {
                          throw new Error ("");
                          // throw new Error ("Error: The checklist state is not Draft");
                        })
                      }
                      
                      //Initialize the selected initial values to the first element in list
                      initialValues.legalEntityGL = parentCompanyData[0];
                      initialValues.legalEntitySubsidiary = initialValues.legalEntityGL.legalEntitySubsidiaries[0];
                      initialValues.legalEntityCompany = initialValues.legalEntitySubsidiary.legalEntityCompanies.length > 0
                        ? initialValues.legalEntitySubsidiary.legalEntityCompanies[0]
                        : [];
                      initialValues.legalEntityRegion = initialValues.legalEntityCompany.length === undefined // if legalEntityCompany length === undefined, it means it is an object, so its value was not set to []
                        ? initialValues.legalEntityCompany.legalEntityRegion 
                        : {name: ""}; 

                      initialValues.legalEntityGL = parentCompanyData.filter(el => el.id === checklistData.legalEntityParentCompany.id)[0];
                      initialValues.legalEntitySubsidiary = initialValues.legalEntityGL.legalEntitySubsidiaries.filter(el => el.id === checklistData.legalEntitySubsidiary.id)[0];
                      initialValues.legalEntityCompany = initialValues.legalEntitySubsidiary.legalEntityCompanies.filter(el => el.id === checklistData.legalEntityCompany.id)[0];
                      initialValues.legalEntityRegion = initialValues.legalEntityCompany.legalEntityRegion;
                      initialValues.controlFunctionId = checklistData.controlFunction.id;
                      initialValues.checklistPeriodId = checklistData.checklistPeriod.id;

                      initialValues.operationalScopeIds = checklistData.operationalScopes.map(opScope => opScope.id);
                      if (initialValues.operationalScopeIds.length > 0) {
                        setOperationalScopeIsSelected(true);
                      }
                      // initialValues.checklistTemplateQuantitativeDrivers = checklistData.
                      initialValues.fiscalYear = checklistData.fiscalYear ? checklistData.fiscalYear : new Date().getFullYear();
                      initialValues.supervisedEntity = checklistData.supervisedEntity;
                      initialValues.operativeCompany = checklistData.operativeCompany;
                      initialValues.foreign = checklistData.foreign;
                      initialValues.qualitativeOnly = checklistData.qualitativeOnly;
                      if (!initialValues.qualitativeOnly) {
                        setKpiSettingsHidden(false);
                        initialValues.checklistTemplateQuantitativeDrivers = checklistData.checklistTemplateQuantitativeDrivers
                          .sort((a,b) => a.templateQuantitativeDriver.position > b.templateQuantitativeDriver.position ? 1 : -1)
                          .map((item) => {
                            return {
                              templateQuantitativeDriverId: item.templateQuantitativeDriver.id,
                              templateQuantitativeDriver: {
                                id: item.templateQuantitativeDriver.id,
                                position: item.templateQuantitativeDriver.position,
                                title: item.templateQuantitativeDriver.title,
                              },
                              enabled: item.enabled,
                              weight: item.weight
                            }
                          })
                      }
                      initialValues.qualitativeWeight = checklistData.qualitativeWeight;
                      initialValues.quantitativeWeight = checklistData.quantitativeWeight;
                      initialValues.coverage = checklistData.coverage;
                      initialValues.accuracy = checklistData.accuracy;
                      

                      setAllLegalEntityGL(parentCompanyData
                        .filter(item => item.active)
                        .map((item) => {
                        return {
                          value: item.id,
                          name: item.name
                        }
                      }));
                      //Set scope data for Subsidiary
                      setAllLegalEntitySubsidiary(initialValues.legalEntityGL.legalEntitySubsidiaries
                        .filter(item => item.legalEntityCompanies.length > 0 && item.active)
                        .map((item) => {
                        return {
                          value: item.id,
                          name: item.name
                        }
                      })
                      );
                      //Set scope data for Comapny
                      setAllLegalEntityCompany(initialValues.legalEntitySubsidiary.legalEntityCompanies
                        .filter(item => item.active)
                        .map((item) => {
                        return {
                          value: item.id,
                          name: item.name
                        }
                      }));

                      setAllOperationalScopes(cfData.filter(cf => cf.id === initialValues.controlFunctionId)[0]
                        .operationalScopes.map((item) => {
                          let isChecked = false;
                          for (let opScopeId of initialValues.operationalScopeIds) {
                            if (opScopeId === item.id) {
                              isChecked = true;
                            }
                          }
                        return {
                          value: item.id + "-" + new Date().getTime(),
                          name: item.name,
                          checked: isChecked,
                          active: item.active
                        }
                      }));
                      
                      const checklistPeriodServiceApi = new ChecklistPeriodServiceApi();
                      checklistPeriodServiceApi.getAllChecklistPeriods((checklistPeriodError, checklistPeriodsResponse) => {
                        if (mounted) {
                          if (!checklistPeriodError) {
                            console.log("select data apiResponseData: ", checklistPeriodsResponse)
                            initialValues.checklistPeriods = checklistPeriodsResponse;
                            setAllChecklistPeriods(checklistPeriodsResponse.map(el => (
                              {
                                value: el.id,
                                name: el.name
                              }
                            )));

                            const templateQuantitativeDriverServiceApi = new TemplateQuantitativeDriverServiceApi();
                            templateQuantitativeDriverServiceApi.getTemplateQuantitativeDriverByControlFunctionAndOperationalScope(
                              checklistData.controlFunction.id,
                              checklistData.operationalScopes.map(el => el.id),
                              (driversError, driversData) => {
                                if (mounted) {
                                  if (!driversError) {
                                    console.log("Initial drivers API: ", driversData);
                                    const drivers = driversData.sort(driver => driver.poi)
                                      .sort((a,b) => a.position > b.position ? 1 : -1)
                                      .map(driver => {
                                      let checklistInfoDriver = initialValues.checklistTemplateQuantitativeDrivers.filter(el => el.templateQuantitativeDriverId === driver.id)[0];
                                      return {
                                        id: driver.id,
                                        position: driver.position,
                                        title: driver.title,
                                        checked: checklistInfoDriver ? checklistInfoDriver.enabled : false,
                                        weight: checklistInfoDriver ? checklistInfoDriver.weight : 0
                                      }
                                    })

                                    initialValues.checklistTemplateQuantitativeDrivers = drivers.map(driver => {
                                      return {
                                          templateQuantitativeDriverId: driver.id,
                                          templateQuantitativeDriver: {
                                            id: driver.id,
                                            position: driver.position,
                                            title: driver.title,
                                          },
                                          enabled: driver.checked,
                                          weight: (driver.weight > 0) ? driver.weight : 0
                                        }
                                    })

                                    initialValues.checklistTemplateQuantitativeDrivers.forEach((item, index) => {
                                      initialValues["kpiweight-"+ (index + 1)] = item.weight;
                                    });

                                    setKpiSettings(drivers)
                                    setIsLoading(false);
                                  } else {
                                    setError(() => {
                                      throw new Error ("");
                                      // throw new Error ("Error " + (driversError.response ? driversError.response.statusCode : "") + " " + driversError.message);
                                    })
                                  }
                                }
                              }
                            );
                          } else {
                            setError(() => {
                              throw new Error ("");
                              // throw new Error ("Error " + (driversError.response ? driversError.response.statusCode : "") + " " + driversError.message);
                            })
                          }
                        }
                      })

                    } else {
                      setError(() => {
                        throw new Error ("");
                        // throw new Error ("Error " + (checklistInfoError.response ? checklistInfoError.response.statusCode : "") + " " + checklistInfoError.message);
                      })
                    }
                  }
                })
              });
            } else {
              setError(() => {
                throw new Error ("");
                // throw new Error ("Error " + (compError.response ? compError.response.statusCode : "") + " " + compError.message);
              })
            }
          }
        });
    
    
      // for (const [parentCompany, index] of parentCompanyApi.entries()) {
        
    // }

    return () => { 

      mounted = false;
    }
  }, []);

  const validationSchema = Yup.object().shape({
    fiscalYear: Yup.string().required("Fiscal Year is required")
        .matches(
            /^20[1-9][0-9]$/,
            "Fiscal Year must be a year [YYYY] between 2010 and 2099"
        ),
    accuracy: Yup.number().typeError('Accuracy must be a number')
        .min(1, 'Accuracy min value is 1')
        .max(100, 'Accuracy max value is 100'),
    coverage: Yup.number()
        .min(0, 'Coverage min value is 0')
        .max(100, 'Coverage max value is 100'),
    qualitativeWeight: Yup.number()
        .min(0, 'Qualitative Module Weight min value is 0')
        .max(100, 'Qualitative Module Weight max value is 100'),
    quantitativeWeight: Yup.number()
        .min(0, 'Quantitative Module Weight min value is 0')
        .max(100, 'Quantitative Module Weight max value is 100'),
    "kpiweight-1": Yup.number()
        .min(0, 'KPI Weight min value is 0')
        .max(100, 'KPI Weight max value is 100'),
    "kpiweight-2": Yup.number()
        .min(0, 'KPI Weight min value is 0')
        .max(100, 'KPI Weight max value is 100'),
    "kpiweight-3": Yup.number()
        .min(0, 'KPI Weight min value is 0')
        .max(100, 'KPI Weight max value is 100'),
    "kpiweight-4": Yup.number()
        .min(0, 'KPI Weight min value is 0')
        .max(100, 'KPI Weight max value is 100'),
    "kpiweight-5": Yup.number()
        .min(0, 'KPI Weight min value is 0')
        .max(100, 'KPI Weight max value is 100'),
    "kpiweight-6": Yup.number()
        .min(0, 'KPI Weight min value is 0')
        .max(100, 'KPI Weight max value is 100')
  });

  const submitFormHandler = (values) => {
      console.log("form values", values);
      const err = checkConstraints(values);
      if(!err.notValid) {
          modalDataHandler("Update checklist", "Save changes?", 'confirmation', () => checkAssessmentIsFrozenHandler(values));
      } else {
        modalDataHandler("", "Error in values", 'error', () => setModalShow(false));
      }
  }

  const checkConstraints = function(values, props) {
    console.log("check constraints", values);

    const errors = {};
    if(values.operationalScopeIds) {
      if(values.operationalScopeIds.length === 0) {
        errors.operationalScopeIds = "Select at least 1 Operational Area";
      }
      console.log("opScope ids: ", values.operationalScopeIds);
      if(values.qualitativeOnly) {
        if(values.quantitativeWeight === 0) { // this check, combined with initial values.quantitativeWeight: 1, is used to prevent the error message below on first load
          if(values.coverage + values.qualitativeWeight !== 100) {
            errors.coverage = "Invalid Coverage";
          }
        }
        } else {
        if(values.quantitativeWeight === 0) {
          if (opScopesHaveKPIs(values.controlFunctionId, values.operationalScopeIds)) {
            errors.kpiCoverage = "Invalid KPI Coverage, Quantitative Module Weight must be > 0";
          }
        } else {
          if(values.checklistTemplateQuantitativeDrivers && values.checklistTemplateQuantitativeDrivers.length > 0) {
            let totalKPICoverage = 0;
            let drivers = values.checklistTemplateQuantitativeDrivers;
            console.log("drivers ", drivers);
            drivers.filter((item) => item.enabled === true).forEach((item) => {
              let driverIndex = drivers.findIndex(el => el.templateQuantitativeDriverId === item.templateQuantitativeDriverId)
              // console.log("item.templateQuantitativeDriverId ", item.templateQuantitativeDriverId)
              // console.log("drivers[index]: ", drivers[driverIndex]);
              if (values[`kpiweight-${driverIndex + 1}`] === 0) {
                errors.kpiIndividualCoverage = "Selected KPI must have a value greater than 0";
              }
              totalKPICoverage += values[`kpiweight-${driverIndex + 1}`];
            });
            console.log("totalKPICoverage ", totalKPICoverage)
            console.log("quantitativeWeight ", values.quantitativeWeight)
            if(totalKPICoverage !== values.quantitativeWeight) {
              if (kpiSettings) {
                errors.kpiCoverage = "Invalid KPI Coverage";
              }
            }
          }
        }

        if(values.coverage + values.qualitativeWeight + values.quantitativeWeight !== 100) {
          errors.coverage = "Invalid Coverage";
        }
      }
    } else {
      errors.notValid = true;
    }

    return errors;

  }

  const opScopesHaveKPIs = function (controlFunctionId, opScopes) {
    if (opScopes.length === 1 && controlFunctionId == 2 && opScopes[0] == 2) { // control function is Risk Management, op scope is Governance
      return false;
    } else {
      return true;
    }
  }

  const checkAssessmentIsFrozenHandler = (values) => {
    const checklistServicesApi = new ChecklistServicesApi();

    checklistServicesApi.checkAssessmentIsFrozen(values.fiscalYear,  values.checklistPeriodId, (error, isFrozen) => {
      if (!error) {
        if (!isFrozen) {
          addChecklist(values);
        } else {
          setIsLoading(false);
          modalDataHandler(``, "Error! The provided checklist period and fiscal year belong to an assessment that is frozen.", 'error', () => setModalShow(false));
        }
      } else {
        setError(() => {
          throw new Error ("");
          // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
        })
      }
    })
  }

  const addChecklist = function(formValues) {
    setIsLoading(true);

    //recover weight values from the form and populate the object for the api call
    console.log("formValues.checklistTemplateQuantitativeDrivers ", formValues.checklistTemplateQuantitativeDrivers)
    if(formValues.checklistTemplateQuantitativeDrivers) {
      formValues.checklistTemplateQuantitativeDrivers.forEach((item, index) => {
        if(formValues["kpiweight-"+(index+1)]) {
          item.weight = formValues["kpiweight-"+(index+1)];
        }
      });
    }

    const apiInput = {
      "legalEntityParentCompanyId": formValues.legalEntityGL.id,
      "legalEntitySubsidiaryId": formValues.legalEntitySubsidiary.id,
      "legalEntityCompanyId": formValues.legalEntityCompany.id,
      "legalEntityRegionId": formValues.legalEntityRegion.id,
      "checklistPeriodId": formValues.checklistPeriodId,
      "controlFunctionId": formValues.controlFunctionId,
      "operationalScopeIds": formValues.operationalScopeIds,
      "checklistTemplateQuantitativeDrivers": formValues.checklistTemplateQuantitativeDrivers,
      "fiscalYear": formValues.fiscalYear,
      "supervisedEntity": (formValues.supervisedEntity.toString() === "true"),
      "operativeCompany": (formValues.operativeCompany.toString() === "true"),
      "foreign": (formValues.foreign.toString() === "true"),
      "qualitativeOnly": formValues.qualitativeOnly,
      "qualitativeWeight": formValues.qualitativeWeight,
      "quantitativeWeight": formValues.quantitativeWeight,
      "coverage": formValues.coverage,
      "accuracy": formValues.accuracy
    }

    console.log("apiInput: ", apiInput);
    const checklistServicesApi = new ChecklistServicesApi();

    apiInput.id = parseInt(checklistId);
    console.log("checklistId: ", checklistId);
    checklistServicesApi.updateChecklist(apiInput, checklistId, (error, data) => {
      if (!error) {
        setIsLoading(false);
        console.log("responseData: ", data);
        
        console.info("checklist updated", data, error);
        history.push("/edit-checklist?checklistId="+data.id);
      } else {
        setIsLoading(false);
        modalDataHandler(`Error ${(error.response ? error.response.statusCode : "")}`, "Error! The checklist could not be updated!", 'error', () => setModalShow(false));
      }
    })
  }

  //Reset Methods
  const resetOperationalScope = function(setFieldValuesFn, givenValue) {
    console.log("new cf id ", givenValue);
    setAllOperationalScopes(initialValues.controlFunctionsApiResponse
      .filter((item) => item.id == (givenValue ? givenValue : initialValues.controlFunctionId))[0].operationalScopes.map((item) => {
      return {
        value: item.id + "-" + new Date().getTime(),
        name: item.name,
        // checked: false,
        active: item.active
      }
    }));
    setFieldValuesFn("operationalScopeIds", []);
    //Reset the visibility of the last parts of the form
    setOperationalScopeIsSelected(false);
  }

  const resetKpiSettings = function() {
    setKpiSettings(false);
    setKpiSettingsHidden(true);
  }

  const resetWeights = function(setFieldValuesFn) {
    setFieldValuesFn("qualitativeOnly", true);
    setFieldValuesFn("qualitativeWeight", 0);
    setFieldValuesFn("quantitativeWeight", 0);
    setFieldValuesFn("coverage", 0);
    setFieldValuesFn("kpiweight-1", 0);
    setFieldValuesFn("kpiweight-2", 0);
    setFieldValuesFn("kpiweight-3", 0);
    setFieldValuesFn("kpiweight-4", 0);
    setFieldValuesFn("kpiweight-5", 0);
    setFieldValuesFn("kpiweight-6", 0);
  }

  const changeGL = function(e, values, setFieldValuesFn) {
    const legalEntityGL = initialValues.legalEntityApiResponse
        .filter((item) => item.id == e.target.value)[0];
    const legalEntitySubsidiary = legalEntityGL.legalEntitySubsidiaries[0];
    const legalEntityCompany = legalEntitySubsidiary.legalEntityCompanies[0];
    const legalEntityRegion = legalEntityCompany.legalEntityRegion;

    setFieldValuesFn("legalEntityGL", legalEntityGL);
    setFieldValuesFn("legalEntitySubsidiary", legalEntitySubsidiary);
    setFieldValuesFn("legalEntityCompany", legalEntityCompany);
    setFieldValuesFn("legalEntityRegion", legalEntityRegion);

    //Set scope data for Subsidiary
    setAllLegalEntitySubsidiary(legalEntityGL.legalEntitySubsidiaries.map((item) => {
      return {
        value: item.id,
        name: item.name
      }
    }));
    //Set scope data for Comapny
    setAllLegalEntityCompany(legalEntitySubsidiary.legalEntityCompanies.map((item) => {
      return {
        value: item.id,
        name: item.name
      }
    }));

    // resetOperationalScope(setFieldValuesFn);
    // resetKpiSettings();
    // resetWeights(setFieldValuesFn);
  };

  const changeSubsidiary = function(e, values, setFieldValuesFn) {
    const legalEntitySubsidiary = initialValues.legalEntityApiResponse
        .filter((item) => item.id == values.legalEntityGL.id)[0].legalEntitySubsidiaries
        .filter((item) => item.id == e.target.value)[0];
    const legalEntityCompany = legalEntitySubsidiary.legalEntityCompanies[0];
    const legalEntityRegion = legalEntityCompany.legalEntityRegion;

    setFieldValuesFn("legalEntitySubsidiary", legalEntitySubsidiary);
    setFieldValuesFn("legalEntityCompany", legalEntityCompany);
    setFieldValuesFn("legalEntityRegion", legalEntityRegion);

    //Set scope data for Comapny
    setAllLegalEntityCompany(legalEntitySubsidiary.legalEntityCompanies.map((item) => {
      return {
        value: item.id,
        name: item.name
      }
    }));

    // resetOperationalScope(setFieldValuesFn);
    // resetKpiSettings();
    // resetWeights(setFieldValuesFn);
  };

  const changeLegalEntity = function(e, values, setFieldValuesFn) {
    console.log("target value ", e.target.value);
    const legalEntityCompany = initialValues.legalEntityApiResponse
        .filter((item) => item.id == values.legalEntityGL.id)[0].legalEntitySubsidiaries
        .filter((item) => item.id == values.legalEntitySubsidiary.id)[0].legalEntityCompanies
        .filter((item) => item.id == e.target.value)[0];
    const legalEntityRegion = legalEntityCompany.legalEntityRegion;

    setFieldValuesFn("legalEntityCompany", legalEntityCompany);
    setFieldValuesFn("legalEntityRegion", legalEntityRegion);

    // resetOperationalScope(setFieldValuesFn);
    // resetKpiSettings();
    // resetWeights(setFieldValuesFn);
  };

  const changePeriod = function(e, values, setFieldValuesFn) {
    console.log("target value ", e.target.value);

    const periodId = initialValues.checklistPeriods
      .filter((item) => item.id == e.target.value)[0].id;

    setFieldValuesFn("checklistPeriodId", periodId);
  };

  const controlFunctionChange = function(e, setFieldValueFn) {
    setFieldValueFn("controlFunctionId", e.target.value);
    setFieldValueFn("operationalScopeIds", []);
    
    resetOperationalScope(setFieldValueFn, e.target.value);
    resetWeights(setFieldValueFn);
    resetKpiSettings();
  };

  const operationalScopeChange = function (e, values, setFieldValueFn) {
    let selectedItems = values.operationalScopeIds;
    const cleanValue = parseInt(e.target.value.split("-")[0]);
    let selectedItemsBefore = [];
    if(e.target.checked) {
      selectedItemsBefore = [...selectedItems];
      selectedItems.push(cleanValue);
    } else {
      selectedItems = selectedItems.filter((item) => item != cleanValue);
    }
    setFieldValueFn("operationalScopeIds", selectedItems)
    //If some operational scope is selected, then enable the final parts of the form
    if(selectedItems.length === 0) {
      setOperationalScopeIsSelected(false);
      resetWeights(setFieldValueFn);
      resetKpiSettings();
    } else { // controlFunctionId, opScopes
      if (!opScopesHaveKPIs(values.controlFunctionId, selectedItems)) {
        setOperationalScopeIsSelected(true);
        setFieldValueFn("quantitativeWeight", 0);
        setFieldValueFn("kpiweight-1", 0);
        setFieldValueFn("kpiweight-2", 0);
        setFieldValueFn("kpiweight-3", 0);
        setFieldValueFn("kpiweight-4", 0);
        setFieldValueFn("kpiweight-5", 0);
        setFieldValueFn("kpiweight-6", 0);
        // resetWeights(setFieldValueFn);
        // resetKpiSettings();
        setKpiSettings([])
      } else {
        setOperationalScopeIsSelected(true);
        if ((!values.qualitativeOnly && kpiSettings.length === 0) ||
         (!opScopesHaveKPIs(values.controlFunctionId, selectedItemsBefore))) { // if the previously selected OpScope didn't have KPIs, start the drivers API function
          driversApiHandler(values, setFieldValueFn);
        }
      }
    }
  };

  const changeQualitativeEval = function (e, values, setFieldValueFn) {
    let qualOnly = e.target.value === 'true';
    console.log('qualOnly ', qualOnly);
    if(!qualOnly) {
      if (values.operationalScopeIds.length > 0) {
        driversApiHandler(values, setFieldValueFn);
      }
    } else {
      setKpiSettingsHidden(true);
      resetKpiSettings();
      resetWeights(setFieldValueFn);
      setFieldValueFn("qualitativeOnly", true);
      setFieldValueFn("checklistTemplateQuantitativeDrivers", []);
    }
  };

  const driversApiHandler = function (values, setFieldValueFn) {
    setIsKpiSettingsLoading(true);
      const templateQuantitativeDriverServiceApi = new TemplateQuantitativeDriverServiceApi();
      templateQuantitativeDriverServiceApi.getTemplateQuantitativeDriverByControlFunctionAndOperationalScope(
        values.controlFunctionId,
        values.operationalScopeIds,
        (error, data) => {
          if (!error) {
            console.log("quantitative drivers API: ", data)
            const transformedData = data
            .sort((a,b) => a.position > b.position ? 1 : -1)
            .map((item) => {
              return {
                templateQuantitativeDriverId: item.id,
                templateQuantitativeDriver: {
                  id: item.id,
                  position: item.position,
                  title: item.title,
                },
                enabled: false,
                weight: 0
              }
            })
            console.log("transformedData ", transformedData)
            setFieldValueFn("checklistTemplateQuantitativeDrivers", transformedData);
            
            setKpiSettings(data);
            setFieldValueFn("qualitativeOnly", false);
            setKpiSettingsHidden(false);
            setIsKpiSettingsLoading(false);
          } else {
            setError(() => {
              throw new Error ("");
              // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
            })
          }
        });
  }

  const changeKpiSettings = function(e, values, setFieldValueFn) {
    const kpiData = values.checklistTemplateQuantitativeDrivers;
    if(e.target.checked) {
      kpiData.filter((item) => item.templateQuantitativeDriver.id == e.target.value)[0].enabled = true;
    } else {
      kpiData.filter((item) => item.templateQuantitativeDriver.id == e.target.value)[0].enabled = false;
    }
    setFieldValueFn("checklistTemplateQuantitativeDrivers", kpiData);
  }

  const modalDataHandler = (title, message, modType, action) => {
    setModalTitle(title);
    setModalMessage(message);
    setModalShow(true);
    setModalType(modType);
    setModalAction(action ? () => action : null);
  }

  return (
    <div className={styles.form}>
      <GenericModal
        show={modalShow}
        handleClose={() => setModalShow(false)}
        action={modalAction}
        title={modalTitle}
        message={modalMessage}
        modalType={modalType}
      />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        validate={checkConstraints}
        onSubmit={submitFormHandler}
        enableReinitialize
        validateOnChange={true}
        validateOnMount={true}
      >
        {({
            values,
            errors,
            touched,
            isValid,
            setFieldValue,
            validateForm
          }) => {
          return (
            <Form>
              <p className="text-start fw-bold mt-3 mb-0">Scope</p>
              {/* {isLoading && } */}
                <Row>
                  <Col xs={{ span: 5, order: 1 }} className="p-1">
                    <Col className="text-start">
                      <label className="fw-bold mb-2 ms-1">
                        Legal Entity (Group level)
                      </label>
                    </Col>
                    <Col sm={12} className="p-0">
                      <Select
                        data={allLegalEntityGL}
                        selectedValue={values.legalEntityGL.id}
                        isLoading={isLoading}
                        onChange={(event) =>
                          changeGL(event, values, setFieldValue)
                        }
                      />
                    </Col>
                  </Col>
                  <Col xs={{ span: 5, order: 2 }} className="p-1">
                    <Col className="text-start">
                      <label className="fw-bold mb-2 ms-1">Region</label>
                    </Col>
                    <Col sm={12} className="p-0">
                      {/* <input type="text" name="region" value={values.legalEntityRegion.name} readOnly={true}/> */}
                      <span className="fw-bold nexiColor ms-1">
                        {values.legalEntityRegion.name}
                      </span>
                    </Col>
                  </Col>
                  <Col xs={{ span: 2, order: 3 }} className="d-flex ps-1">
                    <img
                      src={nexiLogo}
                      className={`${styles.logo}`}
                      alt="nexi-group"
                    />
                  </Col>
                  <Col xs={{ span: 5, order: 4 }} className="p-1">
                    <Col className="text-start">
                      <label className="fw-bold mb-2 ms-1">
                        Legal Entity (Subsidiary)
                      </label>
                    </Col>
                    <Col sm={12} className="p-0">
                      <Select
                        data={allLegalEntitySubsidiary}
                        selectedValue={values.legalEntitySubsidiary.id}
                        isLoading={isLoading}
                        onChange={(event) =>
                          changeSubsidiary(event, values, setFieldValue)
                        }
                      />
                    </Col>
                  </Col>
                  <Col xs={{ span: 5, order: 5 }} className="p-1">
                    <Col className="text-start">
                      <label
                        htmlFor="group-level"
                        className="fw-bold mb-2 mb-1"
                      >
                        Fiscal Year
                      </label>
                    </Col>
                    <Col sm={12} className="p-0">
                      <Field
                        type="text"
                        name="fiscalYear"
                        className={`${styles['w-115px']} fw-bold nexiColor`}
                      />
                      {/* {errors.fiscalYear ? (
                        <div className={styles.errorsList}>
                          {errors.fiscalYear}
                        </div>
                      ) : null} */}
                    </Col>
                  </Col>
                  <Col xs={{ span: 5, order: 5 }} className="p-1">
                    <Col className="text-start">
                      <label className="fw-bold mb-2 ms-1">
                        Legal Entity (Company)
                      </label>
                    </Col>
                    <Col sm={12} className="p-0">
                      <Select
                        data={allLegalEntityCompany}
                        selectedValue={values.legalEntityCompany.id}
                        isLoading={isLoading}
                        onChange={(event) =>
                          changeLegalEntity(event, values, setFieldValue)
                        }
                      />
                    </Col>
                  </Col>
                  <Col xs={{ span: 5, order: 5 }} className="p-1">
                    <Col className="text-start">
                      <label className="fw-bold mb-2 ms-1">
                        Period
                      </label>
                    </Col>
                    <Col sm={12} className="p-0">
                      <Select
                        data={allChecklistPeriods}
                        selectedValue={values.checklistPeriodId}
                        isLoading={isLoading}
                        onChange={(event) =>
                          changePeriod(event, values, setFieldValue)
                        }
                      />
                    </Col>
                  </Col>
                </Row>
              <div className="hr"></div>
              {!isLoading && (
                <Row className={styles.mh_px_100}>
                  <Col>
                    <DropdownChecklist
                      data={allControlFunctions}
                      inputType={"radio"}
                      name={"controlFunctions"}
                      emptyListMessage={"Select one Control function"}
                      defaultValue={values.controlFunctionId}
                      onChange={(event) =>
                        controlFunctionChange(event, setFieldValue)
                      }
                    >
                      Control Function:
                    </DropdownChecklist>
                  </Col>
                  <Col>
                    <DropdownChecklist
                      data={allOperationalScopes}
                      inputType={"checkbox"}
                      name={"operationalScopes"}
                      emptyListMessage={"Select one or more Operational areas"}
                      onChange={(event) =>
                        operationalScopeChange(event, values, setFieldValue)
                      }
                    >
                      Operational Areas:
                    </DropdownChecklist>
                  </Col>
                </Row>
              )}

              {!isLoading && (
                <Block className="mt-2">
                  <Row>
                    <Col xs={3} className="text-start">
                      <label className="fst-italic">Supervised entity:</label>
                    </Col>
                    <Col xs={3} className="text-start">
                      <label className="fst-italic">Operating legal entity:</label>
                    </Col>
                    <Col xs={3} className="text-start">
                      <label className="fst-italic">Other region:</label>
                    </Col>
                  </Row>
                  <Row>
                    {["supervisedEntity", "operativeCompany", "foreign"].map(el => {
                      return <Col xs={3} className="pb-1">
                        <select
                          id={el}
                          name={el}
                          className={`nexiColor smallItalic fw-bold w-50`}
                          size="sm"
                          defaultValue={values[el]}
                          onChange={(e) =>
                            setFieldValue(el, e.target.value)
                          }
                        >
                          <option value={true}>Yes</option>
                          <option value={false}>No</option>
                        </select>
                        {/* <select
                          id={el}
                          name={el}
                          className={`nexiColor smallItalic fw-bold w-50`}
                          size="sm"
                          defaultValue={values[el]}
                          onChange={(e) =>
                            setFieldValue(el, e.target.value)
                          }
                        >
                          <option value={true}>Yes</option>
                          <option value={false}>No</option>
                        </select> */}
                      </Col>
                    })} 
                  </Row>
                </Block>
              )}

              {!isLoading && <AssessmentSettings
                onChangeQualitativeEval={(event) =>
                  changeQualitativeEval(event, values, setFieldValue)
                }
                isEditChecklist={true}
                qualOnly={values.qualitativeOnly}
                showKPIs={opScopesHaveKPIs(values.controlFunctionId, values.operationalScopeIds)}
              />}

              {/* {!isKpiSettingsLoading && !kpiSettingsHidden && (
                <KpiSettings
                  disabled={false}
                  data={kpiSettings}
                  isEditChecklist={isEditChecklist}
                  onChange={(event) =>
                    changeKpiSettings(event, values, setFieldValue) &&
                    validateForm()
                  }
                />
              )} */}
              
              {/* KPI SETTINGS */}
              {!isLoading && !isKpiSettingsLoading && !kpiSettingsHidden && <div>
                <p className="text-start fw-bold mt-3 mb-0">KPI Settings</p>
                <div className={` $"hr" mb-3`}></div>
                <Block disabled={false}>
                  <Row>
                  {kpiSettings.length === 0 && <p>No KPI settings available...</p>} 
                    {kpiSettings.length > 0 && kpiSettings.map((item, index) =>
                      <Col xs={4} key={index}>
                        <div onChange={(event) =>
                              changeKpiSettings(event, values, setFieldValue) &&
                              validateForm()
                            }>
                            <input id={"kpi-" + item.id} name={"kpi-" + item.id} value={item.id} defaultChecked={item.checked ? true : false} type="checkbox" />
                            <label htmlFor={"kpi-" + item.id} className="fw-bold ms-2">KPI {index + 1}</label>
                        </div>
                        <label>{item.title}</label>
                        <div className="mt-2">
                          <label className="fst-italic">KPI {index + 1} Weight (%)</label>
                          <InputField
                              className="ms-2"
                              type="number"
                              fieldtype="number"
                              name={"kpiweight-" + (index + 1)}
                              id={"kpiweight-" + (index + 1)}
                          />
                        </div>
                      </Col>
                    )}
                  </Row>
                </Block>
              </div>}

              {isKpiSettingsLoading /* &&  kpiSettingsHidden */ ? (
                <div className={styles.kpiLoading}>Kpi Settings loading...</div>
              ) : null}

              {!isLoading && operationalScopeIsSelected && <FinalScore />}

              {!isLoading && (
                <div className="w-100 d-flex justify-content-center position-relative">
                  <SubmitButton
                    type="submit"
                    disabled={!isValid}
                    className={`mt-3 mb-1`}
                  >
                    Update
                  </SubmitButton>
                  <ul className={styles.errorsList}>
                    {Object.values(errors).map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              )}
              {isLoading && (
                <div className="spinnerContainer">
                  <div className="spinner-border text-primary " role="status">
                    <span className="sr-only"></span>
                  </div>
                </div>
              )}
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default EditNewChecklist;
